var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7498 4.71094L8.99976 10.8984L2.24976 4.71094",
    stroke: "white",
    strokeWidth: 1.1084,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.24976 4.71094H15.7498V14.2734C15.7498 14.4226 15.6905 14.5657 15.585 14.6712C15.4795 14.7767 15.3364 14.8359 15.1873 14.8359H2.81226C2.66307 14.8359 2.52 14.7767 2.41451 14.6712C2.30902 14.5657 2.24976 14.4226 2.24976 14.2734V4.71094Z",
    stroke: "white",
    strokeWidth: 1.1084,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76929 9.77344L2.42554 14.6742",
    stroke: "white",
    strokeWidth: 1.1084,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.574 14.6742L10.2302 9.77344",
    stroke: "white",
    strokeWidth: 1.1084,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.47157e2e5ab114785f2555b9a086a740.svg";
export { ForwardRef as ReactComponent };